// extracted by mini-css-extract-plugin
export var button = "bottom-banner-module--button--fd7c4";
export var card = "bottom-banner-module--card--a59fa";
export var container = "bottom-banner-module--container--075c6";
export var header = "bottom-banner-module--header--5d16c";
export var icon = "bottom-banner-module--icon--7266a";
export var text = "bottom-banner-module--text--e1165";